import { render, staticRenderFns } from "./Rolemanagementpermissionlisttable.vue?vue&type=template&id=17c32a2d&scoped=true&"
import script from "./Rolemanagementpermissionlisttable.vue?vue&type=script&lang=js&"
export * from "./Rolemanagementpermissionlisttable.vue?vue&type=script&lang=js&"
import style0 from "./Rolemanagementpermissionlisttable.vue?vue&type=style&index=0&id=17c32a2d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c32a2d",
  null
  
)

export default component.exports